import React from "react";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";

interface AppTimePickerProps {
  value?: string | null;
  onChange: (value: string | null) => void;
}

const AppTimePicker: React.FC<AppTimePickerProps> = ({ value, onChange }) => {
  return (
    <TimePicker
      value={value ? dayjs(value, "HH:mm") : null}
      onChange={(newValue) => {
        onChange(newValue ? newValue.format("HH:mm") : null);
      }}
      slotProps={{
        textField: {
          fullWidth: true,
          size: "small",
          variant: "outlined",
          sx: {
            marginLeft: "5px",

            "& .MuiInputBase-input": {
              fontSize: "0.9rem",
            },
          },
        },
      }}
    />
  );
};

export default AppTimePicker;
